import { useEffect, useState } from 'react';
import { API_BASE } from '../utils/apiBase';

const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const BASE = `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/f_auto,q_auto`;

export const cloudinaryUrl = (filename) => `${BASE}/${filename}`;
export const logoUrl = () => cloudinaryUrl('logo_sav.png');

export function useCloudinaryFolder(folder) {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    async function loadImages() {
      try {
        setLoading(true);
        setError('');

        const response = await fetch(
          `${API_BASE}/public-images?folder=${encodeURIComponent(folder)}`
        );

        if (!response.ok) {
          throw new Error('No se pudieron cargar las imagenes.');
        }

        const data = await response.json();

        if (!cancelled) {
          setImages(data.images || []);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'No se pudieron cargar las imagenes.');
          setImages([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadImages();

    return () => {
      cancelled = true;
    };
  }, [folder]);

  return { images, loading, error };
}
